'use strict';

exports = module.exports = require('./lib/memoizer')['default'];
exports['default'] = exports;



/*****************
 ** WEBPACK FOOTER
 ** /jobvolume/donatenodeweb-ci-9488/workspace/Release/~/intl-format-cache/index.js
 ** module id = 199
 ** module chunks = 0 1 2 3 4 5 6
 **/